<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Consultas SPC"
                icon="el-icon-notebook-2"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Nova Consulta
                    </el-button>
                </template>
            </MacroSubHeader>

            <!-- Filters -->
            <div class="d-flex align-items-center justify-content-between px-3 mt-3" :style="{ gap: '20px' }">
                <div class="d-flex align-items-center" :style="{ gap: '8px', width: '375px' }">
                    <el-input
                        v-model="filters.search"
                        size="small"
                        placeholder="Buscar por CPF/CNPJ"
                        prefix-icon="el-icon-search"
                        clearable
                        :style="{ maxWidth: '375px' }"
                        v-mask="['##.###.###/####-##', '###.###.###-##']"
                        @keyup.enter.native.prevent="setFilters()"
                    />

                    <el-button
                        size="small" 
                        type="primary"
                        circle
                        @click="setFilters()"
                    >
                        <i class="el-icon-search"></i>
                    </el-button>
                </div>

                <div class="d-flex justify-content-end">
                    <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                        <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="latest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-top mr-2"></i>
                                    Mais Recentes
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item command="oldest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-bottom mr-2"></i>
                                    Mais Antigos
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>

            <CardBase>
                <SPCList ref="SPCListView"/>
            </CardBase>
        </CardBase>

        <!-- SPCCreateModal -->
        <SPCCreateModal ref="SPCCreateModal" @created="handleDispatch"/>
    </div>
</template>

<script>    
    //Components
    import 
    {
        Dropdown,
        DropdownMenu,
        DropdownItem
    } from 'element-ui'

    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";
    
    import SPCCreateModal from '@/components/_macro/spc/SPCCreateModal.vue';
    import SPCList from '../_macro/spc/SPCList.vue';

    // Utils
    import { formatClear } from '@/util/formatters';

    export default {
        name: "centros-distribuicao",
        data() {
            return {
                filters: {
                    search: '',
                    orderBy: 'latest',
                }
            }
        },
        methods: {
            openModal() {
                this.$refs.SPCCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.SPCListView.fetch();
            },
            /**Filters */
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },
            setFilters() {
                this.$set(this.$refs.SPCListView.filters, 'search', this.formatClear(this.filters.search));
            },
            formatClear,
        },
        watch: {
            "filters.search": {
                handler(_newValue, _oldValue) {
                    if(_newValue == '') {
                        this.$set(this.$refs.SPCListView.filters, 'search', _newValue);
                    }
                }
            },
            "filters.orderBy": {
                handler(_newValue, _oldValue) {
                    this.$set(this.$refs.SPCListView.filters, 'orderBy', _newValue);
                }
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            SPCList,
            SPCCreateModal,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_spc/Index.vue